import { render } from "./HeroiconsSolidTranslate.vue?vue&type=template&id=0745baf6"
const script = {}

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidTranslate.vue"]])

export default __exports__